const OPTIONS_KEYS = [
  "arrayMaxElements",
  "assignSymbol",
  "clear",
  "colorize",
  "console",
  "depth",
  "exit",
  "indent",
  "mapMaxEntries",
  "objectMaxProps",
  "quotesEnd",
  "quotesStart",
  "returns",
  "setMaxValues",
  "stdout",
  "stringMaxLength",
];

export default OPTIONS_KEYS;
